import pl from "@locales/tasks/pl.json";
import en from "@locales/tasks/en.json";
export default {
  pl: pl,
  en: en,
};
